import axios, { AxiosError } from 'axios';
import { ErrorMessage, InternalServerError } from '../types/types';

export const handleAxiosError = (
  error: unknown,
  customMessage: string,
): InternalServerError => {
  if (!axios.isAxiosError(error)) {
    return {
      code: 'UNKNOWN_ERROR',
      message: 'An unknown error occurred.',
    };
  }

  const axiosError = error as AxiosError;
  const status = axiosError.response?.status;
  const responseData = axiosError.response?.data as ErrorMessage;

  switch (status) {
    case 401:
      return {
        code: 'UNAUTHORIZED',
        message:
          'Your session has expired or you are not authorized to perform this action. Please log in again.',
      };
    case 400:
      return {
        status,
        code: 'BAD_REQUEST',
        details: (axiosError.response?.data as InternalServerError)?.details,
        message: responseData?.message || customMessage,
      };
    case 403:
      return {
        status,
        code: 'FORBIDDEN',
        message:
          "You don't have permission to access this page. Please contact support.",
      };
    case 404:
      return {
        status,
        code: 'NOT_FOUND',
        details: (axiosError.response?.data as InternalServerError)?.details,
        message: responseData?.message || customMessage,
      };
    case 409:
      return {
        code: 'CONFLICT',
        message: responseData?.message || customMessage,
      };
    case 423:
      return {
        code: 'NOT_APPROVED',
        message: responseData?.message || customMessage,
      };
    case 429:
      return {
        code: 'TOO_MANY_REQUESTS',
        message: 'Too many requests. Please try again later.',
      };
    case 502:
      return {
        status,
        code: 'BAD_GATEWAY',
        message:
          'Oops! It seems our service is temporarily unavailable. Please try again later.',
      };
    case 500:
      return {
        status,
        code: 'INTERNAL_SERVER_ERROR',
        message: responseData?.message || 'Internal Server Error',
      };
    default:
      console.log(axiosError);
      if (axiosError.code === 'ERR_NETWORK') {
        return {
          code: axiosError.code,
          message:
            axiosError.message === 'Network Error'
              ? 'Oops! Something went wrong. Please check your internet connection and try again.'
              : axiosError.message,
        };
      }
      return {
        code: 'UNKNOWN_ERROR',
        message: customMessage,
      };
  }
};
